function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M704,197.43a169.29,169.29,0,0,0-33.21-59.53C619.5,79.11,544,49.33,467.73,42c-192-18.38-242.91,99.57-278.21,121.27C120.61,205.65-6.57,262,43.32,365.52c27.53,57.09,108.39,62.17,163,62.52,159.31,1,180.75-22.47,265.51-3.07s170.64,14.24,215-53.13C718.41,323.88,721.3,250.93,704,197.43Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M704,197.43a169.29,169.29,0,0,0-33.21-59.53C619.5,79.11,544,49.33,467.73,42c-192-18.38-242.91,99.57-278.21,121.27C120.61,205.65-6.57,262,43.32,365.52c27.53,57.09,108.39,62.17,163,62.52,159.31,1,180.75-22.47,265.51-3.07s170.64,14.24,215-53.13C718.41,323.88,721.3,250.93,704,197.43Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-29"
  }, /*#__PURE__*/React.createElement("polyline", {
    points: "704.13 254.43 704.13 296.2 730.18 296.2",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "642.58 167.63 642.58 150.89 661.88 150.89 661.88 203.2 673.76 203.2 673.76 258.42 685.64 258.42 685.64 182.86 704.13 182.86 704.13 249.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "63.59 229.2 63.59 203.2 82.89 203.2 82.89 238.07 102.19 238.07 102.19 177.04 146.73 177.04 146.73 232.26 186.81 232.26 186.81 159.61 219.47 159.61 219.47 229.36 251.95 229.36 251.95 75.33 271.44 75.33 271.44 139.26 287.77 139.26 287.77 49.17 327.85 49.17 327.85 238.07 381.3 238.07 381.3 113.11 415.44 113.11 415.44 185.76 445.13 185.76 445.13 89.86 497.09 89.86 497.09 194.48 523.82 194.48 523.82 133.45 544.6 133.45 544.6 174.14 565.38 174.14 565.38 124.73 577.26 124.73 577.26 75.33 595.08 75.33 595.08 215.66 611.36 215.66 611.36 179.95 615.86 179.95 615.86 258.42 642.58 258.42 642.58 172.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "38.35 296.2 63.59 296.2 63.59 233.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.22,
    y: 273.84,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.71,
    y: 273.84,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.46,
    y: 273.84,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.99,
    y: 305.49,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 636.22,
    y: 297.32,
    width: 14.3,
    height: 14.3,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.21,379.5c2.6,1.14,8.95,1,9,1s-1.37-4.16-1.49-4.41c-1.39-2.91-5.8-7.73-9.39-7.24a4.28,4.28,0,0,0-3.44,5.36C611.45,376.69,614,378.53,616.21,379.5Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.4,397.9c2.7.4,8.37-1.25,8.82-1.38a74.48,74.48,0,0,0,3.44,9.51c.78,1.81,1.62,3.6,2.48,5.39-.51-.76-1-1.43-1.06-1.52-2.11-2.44-7.63-5.92-11-4.51a4.28,4.28,0,0,0-1.9,6.09c1.23,2.24,4.17,3.35,6.56,3.69s7.29-.95,8.57-1.31c.34.68.67,1.37,1,2.05,1.65,3.27,3.3,6.52,4.82,9.77.54,1.14,1,2.28,1.52,3.43-.46-.68-.86-1.24-.92-1.32-2.12-2.44-7.64-5.92-11-4.51a4.29,4.29,0,0,0-1.9,6.09c1.23,2.24,4.18,3.34,6.56,3.69s6.82-.82,8.34-1.25c.47,1.19.94,2.38,1.34,3.55.26.8.56,1.56.77,2.38s.45,1.62.67,2.41c.37,1.55.76,3.14,1.09,4.66.23,1.05.43,2.06.64,3.08-.52-1.15-1.59-3.36-1.7-3.54-1.72-2.74-6.65-7-10.16-6.12a4.3,4.3,0,0,0-2.8,5.73c.88,2.4,3.63,3.94,5.93,4.65,2.55.77,8.17.06,8.88,0,.33,1.68.64,3.32.91,4.87.21,1.15.39,2.25.56,3.31h2.25c-.21-1.18-.44-2.41-.7-3.7-.33-1.71-.73-3.53-1.15-5.4a42.92,42.92,0,0,0,4.95-2.32c1.86,2,6.6,4.35,7.22,4.65-.65,1.59-1.29,3.13-1.92,4.57l-1,2.2H661c.19-.45.38-.9.57-1.37.66-1.61,1.34-3.34,2-5.13.68.14,6.25,1.28,8.85.69,2.35-.53,5.2-1.86,6.26-4.19a4.29,4.29,0,0,0-2.37-5.92c-3.43-1.15-8.67,2.74-10.58,5.34-.12.16-1.16,2-1.8,3.11.27-.74.55-1.44.82-2.2.55-1.49,1-3,1.6-4.62.23-.79.47-1.58.71-2.39s.43-1.67.65-2.51c.46-2,.84-4,1.18-6,1.3.48,6,2.1,8.39,1.93s5.43-1.05,6.83-3.19a4.29,4.29,0,0,0-1.44-6.21c-3.22-1.66-9,1.4-11.28,3.68-.14.14-1.6,2-2.38,3,.19-1.23.39-2.44.54-3.69.45-3.59.78-7.23,1.14-10.87.11-1.11.23-2.22.35-3.33.46.17,6,2.22,8.68,2,2.4-.16,5.43-1,6.82-3.19a4.28,4.28,0,0,0-1.44-6.21c-3.22-1.66-9,1.4-11.27,3.68-.18.17-2.27,2.79-2.77,3.49.25-2.45.53-4.88.91-7.27a75.62,75.62,0,0,1,2.08-9.56c.22.08,6,2.25,8.73,2.05,2.41-.16,5.43-1.05,6.83-3.19a4.29,4.29,0,0,0-1.44-6.21c-3.22-1.66-9,1.4-11.28,3.68-.18.18-2.43,3-2.8,3.54,0-.18.09-.37.14-.55a55.73,55.73,0,0,1,3.79-9.05c.82-1.61,1.7-3.1,2.58-4.54,1,.52,5.75,2.81,8.27,2.91s5.51-.45,7.13-2.43a4.28,4.28,0,0,0-.74-6.33c-3-2-9.09.41-11.61,2.42-.14.11-1.42,1.38-2.33,2.32.41-.64.82-1.31,1.22-1.92,1.52-2.28,3.05-4.27,4.41-6,.79-1,1.52-1.87,2.21-2.69,1.27,0,6.39-.18,8.63-1.23s4.68-2.94,5.21-5.44a4.28,4.28,0,0,0-3.58-5.27c-3.6-.39-7.87,4.54-9.19,7.49-.11.26-1.43,4.45-1.37,4.45H689c-.68.78-1.4,1.61-2.17,2.54-1.41,1.73-3,3.7-4.55,5.95a76.32,76.32,0,0,0-4.72,7.52,55.29,55.29,0,0,0-4,9.08s0,.08,0,.11c0-1.06,0-4-.05-4.25-.42-3.2-3.11-9.15-6.66-9.81a4.27,4.27,0,0,0-4.94,4c-.21,2.54,1.63,5.09,3.43,6.7,2,1.81,7.67,3.57,8.12,3.71a74.64,74.64,0,0,0-2.38,9.83c-.35,1.94-.64,3.9-.9,5.87,0-.92,0-1.74,0-1.85-.41-3.21-3.1-9.16-6.66-9.82a4.29,4.29,0,0,0-4.94,4c-.21,2.55,1.64,5.1,3.44,6.71s6.6,3.22,7.87,3.63c-.09.75-.19,1.51-.28,2.26-.44,3.64-.86,7.26-1.37,10.81-.19,1.25-.41,2.47-.63,3.69,0-.81,0-1.5-.05-1.6-.41-3.2-3.1-9.15-6.66-9.81a4.28,4.28,0,0,0-4.94,4c-.21,2.54,1.64,5.09,3.44,6.7s6.14,3.07,7.64,3.56c-.26,1.24-.52,2.49-.83,3.69-.24.81-.4,1.61-.68,2.42s-.51,1.59-.77,2.37c-.54,1.5-1.09,3-1.66,4.49-.39,1-.77,2-1.16,2.92.19-1.24.53-3.68.53-3.88a16.64,16.64,0,0,0-2.23-8.1,5,5,0,0,0-.06-.94,4.29,4.29,0,0,0-5.24-3.64c-3.49.93-5.71,7.07-5.88,10.3,0,.19.12,2.27.22,3.58-.18-.76-.34-1.5-.53-2.28-.37-1.55-.78-3.08-1.22-4.73-.23-.79-.48-1.59-.72-2.4s-.56-1.62-.85-2.44c-.69-1.89-1.48-3.78-2.32-5.66,1.35-.32,6.14-1.54,8.07-3s3.94-3.87,3.93-6.43a4.29,4.29,0,0,0-4.63-4.38c-3.6.39-6.72,6.12-7.37,9.29,0,.19-.26,2.52-.35,3.8-.51-1.13-1-2.26-1.58-3.38-1.61-3.24-3.34-6.47-5-9.69l-1.55-3c.49-.11,6.21-1.44,8.37-3.1,1.91-1.47,3.94-3.87,3.93-6.42a4.29,4.29,0,0,0-4.63-4.39c-3.6.39-6.72,6.12-7.37,9.29,0,.24-.36,3.58-.39,4.44-1.13-2.19-2.24-4.37-3.25-6.57a75.38,75.38,0,0,1-3.53-9.12c.22-.05,6.21-1.41,8.41-3.11,1.92-1.46,3.95-3.87,3.93-6.42a4.28,4.28,0,0,0-4.63-4.39c-3.59.39-6.72,6.12-7.37,9.29,0,.25-.37,3.85-.39,4.5,0-.18-.13-.36-.18-.54a54.63,54.63,0,0,1-1.83-9.63c-.21-1.8-.3-3.53-.35-5.22,1.14-.13,6.34-.83,8.5-2.13s4.35-3.42,4.61-6a4.29,4.29,0,0,0-4.12-4.87c-3.62,0-7.35,5.35-8.35,8.43,0,.16-.41,1.92-.66,3.21,0-.76,0-1.55,0-2.27,0-2.74.18-5.25.35-7.47.11-1.26.23-2.39.36-3.46,1.05-.72,5.23-3.67,6.52-5.78s2.28-5,1.35-7.42a4.29,4.29,0,0,0-5.9-2.42c-3.21,1.66-4.06,8.14-3.53,11.32,0,.28,1.26,4.5,1.32,4.47l.06-.05c-.14,1-.28,2.12-.41,3.32-.22,2.22-.45,4.73-.51,7.48a77.05,77.05,0,0,0,.21,8.87,55.76,55.76,0,0,0,1.64,9.79s0,.08,0,.12c-.57-.9-2.25-3.34-2.4-3.52-2.11-2.44-7.63-5.92-11-4.51a4.29,4.29,0,0,0-1.9,6.09C613.07,396.45,616,397.55,618.4,397.9Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.47,380.9s1.15-4.22,1.19-4.5c.45-3.2-.57-9.65-3.83-11.22a4.28,4.28,0,0,0-5.83,2.58c-.87,2.4.23,5.35,1.55,7.37C675.09,377.51,680.46,380.9,680.47,380.9Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.68,379.5c2.6,1.14,9,1,9,1s-1.37-4.16-1.49-4.41c-1.39-2.91-5.8-7.73-9.39-7.24a4.27,4.27,0,0,0-3.43,5.36C31.92,376.69,34.47,378.53,36.68,379.5Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.88,397.9c2.69.4,8.36-1.25,8.81-1.38A76,76,0,0,0,51.13,406c.78,1.81,1.62,3.6,2.49,5.39-.52-.76-1-1.43-1.06-1.52-2.12-2.44-7.64-5.92-11-4.51a4.29,4.29,0,0,0-1.9,6.09c1.23,2.24,4.18,3.35,6.56,3.69s7.29-.95,8.57-1.31c.34.68.67,1.37,1,2.05,1.64,3.27,3.29,6.52,4.81,9.77.54,1.14,1,2.28,1.52,3.43-.46-.68-.85-1.24-.92-1.32-2.12-2.44-7.64-5.92-11-4.51a4.29,4.29,0,0,0-1.9,6.09c1.23,2.24,4.18,3.34,6.57,3.69s6.81-.82,8.33-1.25c.47,1.19.94,2.38,1.34,3.55.26.8.56,1.56.77,2.38s.45,1.62.67,2.41c.37,1.55.77,3.14,1.09,4.66.23,1.05.44,2.06.64,3.08-.52-1.15-1.59-3.36-1.7-3.54-1.72-2.74-6.65-7-10.16-6.12A4.29,4.29,0,0,0,53.14,444c.87,2.4,3.62,3.94,5.93,4.65,2.54.77,8.16.06,8.87,0,.33,1.68.65,3.32.92,4.87.2,1.15.38,2.25.55,3.31h2.26c-.22-1.18-.45-2.41-.71-3.7-.33-1.71-.72-3.53-1.14-5.4a43.91,43.91,0,0,0,4.94-2.32c1.86,2,6.6,4.35,7.22,4.65-.65,1.59-1.29,3.13-1.92,4.57-.33.76-.66,1.48-1,2.2h2.38c.19-.45.38-.9.57-1.37.67-1.61,1.34-3.34,2-5.13.68.14,6.25,1.28,8.85.69,2.35-.53,5.2-1.86,6.26-4.19a4.28,4.28,0,0,0-2.37-5.92c-3.43-1.15-8.66,2.74-10.58,5.34-.12.16-1.16,2-1.8,3.11.28-.74.55-1.44.82-2.2.55-1.49,1-3,1.6-4.62.23-.79.47-1.58.71-2.39s.43-1.67.65-2.51c.47-2,.84-4,1.18-6,1.31.48,6,2.1,8.39,1.93s5.43-1.05,6.83-3.19a4.28,4.28,0,0,0-1.44-6.21c-3.22-1.66-9,1.4-11.28,3.68-.14.14-1.6,2-2.38,3,.19-1.23.39-2.44.54-3.69.45-3.59.79-7.23,1.14-10.87.11-1.11.23-2.22.35-3.33.46.17,6,2.22,8.68,2,2.41-.16,5.43-1,6.82-3.19a4.28,4.28,0,0,0-1.44-6.21c-3.21-1.66-9,1.4-11.27,3.68-.17.17-2.27,2.79-2.77,3.49.26-2.45.54-4.88.91-7.27a75.62,75.62,0,0,1,2.09-9.56c.21.08,5.95,2.25,8.73,2.05,2.4-.16,5.43-1.05,6.82-3.19a4.29,4.29,0,0,0-1.44-6.21c-3.22-1.66-9,1.4-11.27,3.68-.18.18-2.44,3-2.81,3.54.05-.18.09-.37.14-.55a55.73,55.73,0,0,1,3.79-9.05c.82-1.61,1.7-3.1,2.59-4.54,1,.52,5.75,2.81,8.26,2.91s5.51-.45,7.14-2.43a4.29,4.29,0,0,0-.75-6.33c-3-2-9.09.41-11.61,2.42-.14.11-1.41,1.38-2.33,2.32.41-.64.82-1.31,1.23-1.92,1.51-2.28,3-4.27,4.4-6,.79-1,1.52-1.87,2.21-2.69,1.27,0,6.39-.18,8.63-1.23s4.68-2.94,5.21-5.44a4.28,4.28,0,0,0-3.58-5.27c-3.6-.39-7.87,4.54-9.19,7.49-.11.26-1.43,4.45-1.36,4.45h.07c-.68.78-1.4,1.61-2.17,2.54-1.41,1.73-3,3.7-4.55,5.95A78.24,78.24,0,0,0,98,385.83a55.29,55.29,0,0,0-4,9.08l0,.11c0-1.06,0-4-.06-4.25-.42-3.2-3.1-9.15-6.66-9.81a4.27,4.27,0,0,0-4.94,4c-.21,2.54,1.64,5.09,3.44,6.7,2,1.81,7.66,3.57,8.11,3.71a76.25,76.25,0,0,0-2.38,9.83c-.35,1.94-.63,3.9-.9,5.87,0-.92,0-1.74,0-1.85-.42-3.21-3.11-9.16-6.67-9.82a4.29,4.29,0,0,0-4.94,4c-.2,2.55,1.64,5.1,3.44,6.71s6.6,3.22,7.87,3.63c-.09.75-.19,1.51-.28,2.26-.44,3.64-.85,7.26-1.37,10.81-.18,1.25-.41,2.47-.63,3.69,0-.81,0-1.5,0-1.6-.42-3.2-3.11-9.15-6.66-9.81a4.27,4.27,0,0,0-4.94,4c-.21,2.54,1.63,5.09,3.43,6.7s6.14,3.07,7.65,3.56c-.27,1.24-.53,2.49-.84,3.69-.23.81-.4,1.61-.68,2.42s-.51,1.59-.77,2.37c-.54,1.5-1.09,3-1.66,4.49-.38,1-.77,2-1.16,2.92.2-1.24.53-3.68.53-3.88a16.64,16.64,0,0,0-2.23-8.1,5,5,0,0,0-.06-.94,4.28,4.28,0,0,0-5.23-3.64c-3.5.93-5.72,7.07-5.88,10.3,0,.19.11,2.27.21,3.58-.18-.76-.34-1.5-.53-2.28-.37-1.55-.78-3.08-1.21-4.73-.24-.79-.48-1.59-.73-2.4s-.56-1.62-.84-2.44c-.69-1.89-1.49-3.78-2.33-5.66,1.36-.32,6.15-1.54,8.07-3s3.95-3.87,3.93-6.43a4.29,4.29,0,0,0-4.63-4.38c-3.6.39-6.72,6.12-7.37,9.29,0,.19-.26,2.52-.35,3.8-.51-1.13-1-2.26-1.58-3.38-1.61-3.24-3.33-6.47-5-9.69-.53-1-1-2-1.55-3,.48-.11,6.2-1.44,8.36-3.1,1.91-1.47,4-3.87,3.93-6.42a4.29,4.29,0,0,0-4.63-4.39c-3.6.39-6.72,6.12-7.37,9.29-.05.24-.35,3.58-.39,4.44-1.13-2.19-2.24-4.37-3.25-6.57a75.38,75.38,0,0,1-3.53-9.12c.23-.05,6.21-1.41,8.41-3.11,1.92-1.46,3.95-3.87,3.93-6.42a4.28,4.28,0,0,0-4.62-4.39c-3.6.39-6.72,6.12-7.38,9.29-.05.25-.37,3.85-.38,4.5-.06-.18-.14-.36-.19-.54a55.56,55.56,0,0,1-1.83-9.63c-.2-1.8-.3-3.53-.35-5.22,1.14-.13,6.35-.83,8.5-2.13s4.35-3.42,4.61-6A4.29,4.29,0,0,0,55.12,368c-3.61,0-7.35,5.35-8.34,8.43-.06.16-.42,1.92-.67,3.21,0-.76,0-1.55,0-2.27,0-2.74.17-5.25.35-7.47.1-1.26.23-2.39.35-3.46,1-.72,5.24-3.67,6.52-5.78s2.29-5,1.35-7.42a4.29,4.29,0,0,0-5.9-2.42c-3.21,1.66-4.06,8.14-3.53,11.32.05.28,1.26,4.5,1.32,4.47l.06-.05c-.14,1-.28,2.12-.41,3.32-.22,2.22-.45,4.73-.51,7.48a77.05,77.05,0,0,0,.21,8.87A55.8,55.8,0,0,0,47.54,396l0,.12c-.57-.9-2.24-3.34-2.39-3.52-2.12-2.44-7.64-5.92-11-4.51a4.29,4.29,0,0,0-1.9,6.09C33.54,396.45,36.49,397.55,38.88,397.9Z",
    style: {
      fill: "#1D50FF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,380.9c.06,0,1.16-4.22,1.19-4.5.45-3.2-.57-9.65-3.83-11.22a4.28,4.28,0,0,0-5.83,2.58c-.87,2.4.24,5.35,1.55,7.37C95.56,377.51,100.94,380.9,100.94,380.9Z",
    style: {
      fill: "#1D50FF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.32,92.05H602.77a10.46,10.46,0,0,1,10.46,10.46V431.76a0,0,0,0,1,0,0H89.86a0,0,0,0,1,0,0V102.51A10.46,10.46,0,0,1,100.32,92.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.25,
    y: 115.13,
    width: 480.46,
    height: 284.18,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.64,
    y: 200.47,
    width: 160.01,
    height: 23.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.64,
    y: 321.28,
    width: 160.01,
    height: 23.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.26,
    y: 200.47,
    width: 160.01,
    height: 23.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.64,
    y: 290.1,
    width: 160.01,
    height: 23.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.26,
    y: 290.1,
    width: 160.01,
    height: 23.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.64,
    y: 230.34,
    width: 324.94,
    height: 23.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.64,
    y: 260.21,
    width: 324.94,
    height: 23.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.78,167.71c1.91,0,2.79,1.16,2.79,3.06V177c0,1.87-.88,3-2.79,3H123.9V167.71Zm0,11c1,0,1.46-.62,1.46-1.74v-6.32c0-1.12-.48-1.73-1.48-1.73h-1.47v9.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.21,173.15v1.23h-3v4.37h3.69V180h-5.05V167.71h5.05V169h-3.69v4.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.16,180V167.71h1.37v11H142V180Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.44,167.71V180h-1.37V167.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.87,167.71l2,10.69,2-10.69h1.26L149.82,180h-2l-2.31-12.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.54,173.15v1.23h-3v4.37h3.68V180h-5.05V167.71h5.05V169h-3.68v4.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.22,167.71c1.93,0,2.73,1,2.73,2.81v1c0,1.35-.47,2.19-1.52,2.53,1.12.33,1.54,1.24,1.54,2.56v1.91a3,3,0,0,0,.25,1.47h-1.39a3.16,3.16,0,0,1-.23-1.49v-1.93c0-1.38-.65-1.82-1.79-1.82h-1V180h-1.37V167.71Zm-.35,5.79c1.08,0,1.73-.35,1.73-1.68v-1.18c0-1.1-.4-1.68-1.42-1.68h-1.33v4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.39,175.59l-2.6-7.88h1.43l1.91,6,1.93-6h1.29l-2.61,7.88V180h-1.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.44,177.52,177,180H175.7l2.35-12.28h2L182.39,180H181l-.48-2.47Zm.17-1.18h2.74L179,169.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.33,167.71c1.91,0,2.79,1.16,2.79,3.06V177c0,1.87-.88,3-2.79,3h-2.88V167.71Zm0,11c1,0,1.46-.62,1.46-1.74v-6.32c0-1.12-.47-1.73-1.47-1.73h-1.48v9.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.27,167.71c1.92,0,2.79,1.16,2.79,3.06V177c0,1.87-.87,3-2.79,3H190.4V167.71Zm0,11c1,0,1.45-.62,1.45-1.74v-6.32c0-1.12-.47-1.73-1.47-1.73h-1.47v9.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.08,167.71c1.93,0,2.73,1,2.73,2.81v1c0,1.35-.47,2.19-1.52,2.53,1.12.33,1.54,1.24,1.54,2.56v1.91a3,3,0,0,0,.25,1.47h-1.39a3.16,3.16,0,0,1-.23-1.49v-1.93c0-1.38-.65-1.82-1.79-1.82h-1V180h-1.37V167.71Zm-.35,5.79c1.08,0,1.73-.35,1.73-1.68v-1.18c0-1.1-.4-1.68-1.42-1.68h-1.33v4.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.62,173.15v1.23h-3v4.37h3.68V180h-5.05V167.71h5.05V169h-3.68v4.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.88,170.66V171h-1.3v-.4c0-1.11-.42-1.75-1.4-1.75s-1.41.64-1.41,1.73c0,2.76,4.13,3,4.13,6.47,0,1.86-.9,3.07-2.77,3.07s-2.76-1.21-2.76-3.07v-.7h1.28v.77c0,1.11.46,1.76,1.44,1.76s1.44-.65,1.44-1.76c0-2.73-4.11-3-4.11-6.45,0-1.89.88-3.07,2.72-3.07S215.88,168.8,215.88,170.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,170.66V171h-1.3v-.4c0-1.11-.42-1.75-1.4-1.75s-1.4.64-1.4,1.73c0,2.76,4.12,3,4.12,6.47,0,1.86-.9,3.07-2.77,3.07s-2.76-1.21-2.76-3.07v-.7h1.28v.77c0,1.11.46,1.76,1.44,1.76s1.44-.65,1.44-1.76c0-2.73-4.1-3-4.1-6.45,0-1.89.87-3.07,2.72-3.07S222.4,168.8,222.4,170.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.2,212v1h-2.26v4.25h-1.1v-9.83h3.91v1h-2.81V212Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.71,207.46v9.83h-1.1v-9.83Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,207.46c1.54,0,2.19.79,2.19,2.25v.8a1.84,1.84,0,0,1-1.22,2c.9.27,1.23,1,1.23,2.05v1.53a2.51,2.51,0,0,0,.2,1.18h-1.11a2.56,2.56,0,0,1-.18-1.2v-1.54c0-1.11-.52-1.46-1.43-1.46h-.77v4.2h-1.1v-9.83Zm-.28,4.63c.87,0,1.39-.28,1.39-1.34v-.94c0-.89-.32-1.35-1.14-1.35h-1.06v3.63Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.61,209.82v.27h-1v-.32c0-.89-.34-1.41-1.12-1.41s-1.12.52-1.12,1.39c0,2.2,3.29,2.42,3.29,5.18,0,1.49-.71,2.46-2.21,2.46s-2.21-1-2.21-2.46v-.56h1V215c0,.88.36,1.4,1.15,1.4s1.15-.52,1.15-1.4c0-2.19-3.28-2.4-3.28-5.17,0-1.51.7-2.45,2.17-2.45S143.61,208.33,143.61,209.82Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,217.29v-8.83h-1.81v-1h4.71v1h-1.82v8.83Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.77,217.29h-1v-9.83h1.39l2.27,7.1v-7.1h1v9.83h-1.14l-2.51-7.95Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,215.31l-.38,2h-1l1.88-9.83h1.59l1.88,9.83h-1.1l-.38-2Zm.14-.94H161l-1.11-5.67Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.08,217.27H166l-1.63-7.81v7.83h-1v-9.83H165l1.62,7.85,1.56-7.85h1.53v9.83h-1v-7.9Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.29,211.81v1h-2.4v3.49h3v1h-4v-9.83h4v1h-3v3.35Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.64,217.29v-9.83h1.09v8.83h2.81v1Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.47,215.31l-.38,2h-1l1.88-9.83h1.59l1.88,9.83h-1.1l-.37-2Zm.14-.94h2.19l-1.11-5.67Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.53,209.82v.27h-1v-.32c0-.89-.34-1.41-1.13-1.41s-1.12.52-1.12,1.39c0,2.2,3.3,2.42,3.3,5.18,0,1.49-.72,2.46-2.22,2.46s-2.2-1-2.2-2.46v-.56h1V215c0,.88.37,1.4,1.15,1.4s1.15-.52,1.15-1.4c0-2.19-3.28-2.4-3.28-5.17,0-1.51.7-2.45,2.18-2.45S307.53,208.33,307.53,209.82Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.92,217.29v-8.83h-1.81v-1h4.7v1H311v8.83Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.69,217.29h-1v-9.83h1.39l2.28,7.1v-7.1h1v9.83h-1.13l-2.52-7.95Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.57,215.31l-.38,2h-1l1.88-9.83h1.59l1.88,9.83h-1.09l-.38-2Zm.14-.94h2.19l-1.11-5.67Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,217.27H330l-1.63-7.81v7.83h-.95v-9.83h1.53l1.61,7.85,1.56-7.85h1.53v9.83h-1v-7.9Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.22,211.81v1h-2.4v3.49h2.94v1h-4v-9.83h4v1h-2.94v3.35Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.23,244.44l-.38,2h-1l1.89-9.82h1.58l1.88,9.82H131.1l-.38-2Zm.14-.94h2.19l-1.11-5.67Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.35,236.6c1.53,0,2.23.93,2.23,2.44v5c0,1.5-.7,2.42-2.23,2.42h-2.3V236.6Zm0,8.83c.79,0,1.17-.49,1.17-1.39v-5c0-.9-.38-1.39-1.18-1.39h-1.18v7.83Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9,236.6c1.53,0,2.23.93,2.23,2.44v5c0,1.5-.7,2.42-2.23,2.42h-2.3V236.6Zm0,8.83c.78,0,1.16-.49,1.16-1.39v-5c0-.9-.38-1.39-1.18-1.39h-1.18v7.83Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.35,236.6c1.54,0,2.18.79,2.18,2.25v.8c0,1.08-.37,1.75-1.22,2,.9.26,1.24,1,1.24,2v1.53a2.47,2.47,0,0,0,.19,1.18h-1.1a2.48,2.48,0,0,1-.19-1.19v-1.54c0-1.11-.52-1.46-1.43-1.46h-.77v4.19h-1.09V236.6Zm-.29,4.63c.87,0,1.39-.28,1.39-1.35v-.94c0-.88-.32-1.34-1.13-1.34h-1.07v3.63Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,241v1h-2.4v3.5h2.95v1h-4V236.6h4v1h-2.95V241Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,239v.26h-1v-.32c0-.88-.34-1.4-1.13-1.4s-1.12.52-1.12,1.39c0,2.2,3.3,2.41,3.3,5.18,0,1.48-.72,2.45-2.22,2.45s-2.2-1-2.2-2.45v-.57h1v.62c0,.89.37,1.41,1.15,1.41s1.16-.52,1.16-1.41c0-2.19-3.29-2.4-3.29-5.16,0-1.52.7-2.46,2.18-2.46S159,237.47,159,239Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.2,239v.26h-1v-.32c0-.88-.34-1.4-1.13-1.4s-1.12.52-1.12,1.39c0,2.2,3.3,2.41,3.3,5.18,0,1.48-.72,2.45-2.22,2.45s-2.2-1-2.2-2.45v-.57h1v.62c0,.89.37,1.41,1.15,1.41s1.15-.52,1.15-1.41c0-2.19-3.28-2.4-3.28-5.16,0-1.52.7-2.46,2.18-2.46S164.2,237.47,164.2,239Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,246.42V236.6h1.09v8.83h2.81v1Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,236.6v9.82h-1.1V236.6Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.26,246.42h-1V236.6h1.38l2.28,7.1v-7.1h1v9.82h-1.14l-2.51-7.94Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,241v1h-2.4v3.5h2.95v1h-4V236.6h4v1h-2.95V241Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.26,238.38a2.8,2.8,0,0,1-1.36.42v-.89a1.69,1.69,0,0,0,1.68-1.31h.76v9.82h-1.08Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.23,276l-.38,2h-1l1.89-9.82h1.58l1.88,9.82H131.1l-.38-2Zm.14-.94h2.19l-1.11-5.67Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.35,268.18c1.53,0,2.23.92,2.23,2.44v4.95c0,1.5-.7,2.43-2.23,2.43h-2.3v-9.82Zm0,8.82c.79,0,1.17-.49,1.17-1.39v-5.05c0-.9-.38-1.39-1.18-1.39h-1.18V277Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.9,268.18c1.53,0,2.23.92,2.23,2.44v4.95c0,1.5-.7,2.43-2.23,2.43h-2.3v-9.82Zm0,8.82c.78,0,1.16-.49,1.16-1.39v-5.05c0-.9-.38-1.39-1.18-1.39h-1.18V277Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.35,268.18c1.54,0,2.18.78,2.18,2.24v.8c0,1.08-.37,1.76-1.22,2,.9.27,1.24,1,1.24,2.05v1.53a2.51,2.51,0,0,0,.19,1.18h-1.1a2.48,2.48,0,0,1-.19-1.19v-1.55c0-1.11-.52-1.46-1.43-1.46h-.77V278h-1.09v-9.82Zm-.29,4.63c.87,0,1.39-.28,1.39-1.35v-.94c0-.89-.32-1.35-1.13-1.35h-1.07v3.64Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.18,272.53v1h-2.4V277h2.95v1h-4v-9.82h4v1h-2.95v3.36Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159,270.53v.27h-1v-.32c0-.89-.34-1.41-1.13-1.41s-1.12.52-1.12,1.39c0,2.21,3.3,2.42,3.3,5.18,0,1.49-.72,2.46-2.22,2.46s-2.2-1-2.2-2.46v-.56h1v.62c0,.88.37,1.4,1.15,1.4s1.16-.52,1.16-1.4c0-2.19-3.29-2.4-3.29-5.17,0-1.51.7-2.45,2.18-2.45S159,269.05,159,270.53Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.2,270.53v.27h-1v-.32c0-.89-.34-1.41-1.13-1.41s-1.12.52-1.12,1.39c0,2.21,3.3,2.42,3.3,5.18,0,1.49-.72,2.46-2.22,2.46s-2.2-1-2.2-2.46v-.56h1v.62c0,.88.37,1.4,1.15,1.4s1.15-.52,1.15-1.4c0-2.19-3.28-2.4-3.28-5.17,0-1.51.7-2.45,2.18-2.45S164.2,269.05,164.2,270.53Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.35,278v-9.82h1.09V277h2.81v1Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.17,268.18V278h-1.1v-9.82Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.26,278h-1v-9.82h1.38l2.28,7.1v-7.1h1V278h-1.14l-2.51-7.94Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.52,272.53v1h-2.4V277h2.95v1h-4v-9.82h4v1h-2.95v3.36Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.67,270.56c0,3-3.32,4-3.34,6.29V277h3.23v1h-4.31v-.84c0-3.17,3.33-3.79,3.33-6.56,0-1-.34-1.54-1.15-1.54s-1.15.57-1.15,1.45v.87h-1v-.8c0-1.51.69-2.5,2.2-2.5S191.67,269.06,191.67,270.56Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.66,307v-8.82h-1.82v-1h4.71v1h-1.81V307Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.2,299.56c0-1.5.75-2.47,2.25-2.47s2.26,1,2.26,2.47v5.08a2.16,2.16,0,0,1-2.26,2.47c-1.5,0-2.25-1-2.25-2.47Zm1.08,5.14c0,.9.38,1.42,1.17,1.42s1.16-.52,1.16-1.42v-5.19c0-.89-.36-1.42-1.16-1.42s-1.17.53-1.17,1.42Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.36,307h-1.51l-1.34-9.82h1.06l1.15,8.36,1.1-8.35h1.08l1.08,8.37,1.11-8.38H145L143.71,307h-1.45l-.94-6.66Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.89,307h-1v-9.82h1.39l2.27,7.1v-7.1h1V307H149.4l-2.51-7.94Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.15,297.19,152.28,307h-1l3.88-9.82Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.27,299.56v.89h-1v-.94c0-.89-.35-1.42-1.15-1.42s-1.15.53-1.15,1.42v5.19c0,.88.37,1.42,1.15,1.42s1.15-.54,1.15-1.42v-1.28h1v1.22c0,1.49-.7,2.47-2.21,2.47s-2.21-1-2.21-2.47v-5.08c0-1.49.7-2.47,2.21-2.47S161.27,298.07,161.27,299.56Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.36,297.19V307h-1.09v-9.82Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.9,307v-8.82h-1.81v-1h4.7v1H167V307Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.27,303.49l-2.07-6.3h1.13l1.53,4.83,1.55-4.83h1l-2.1,6.3V307h-1.08Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129,329.34c1.55,0,2.2.91,2.2,2.4v1.18c0,1.56-.72,2.37-2.28,2.37h-1v3.88h-1.1v-9.83Zm-.08,5c.81,0,1.2-.38,1.2-1.32v-1.3c0-.9-.32-1.35-1.12-1.35h-1.05v4Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.14,334.75v4.42h-1.09v-9.83h1.09v4.42h2.42v-4.42h1.09v9.83h-1.09v-4.42Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.69,331.71c0-1.5.74-2.47,2.24-2.47s2.26,1,2.26,2.47v5.08c0,1.49-.74,2.47-2.26,2.47s-2.24-1-2.24-2.47Zm1.08,5.14c0,.9.38,1.42,1.16,1.42s1.17-.52,1.17-1.42v-5.19c0-.89-.37-1.42-1.17-1.42s-1.16.53-1.16,1.42Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.2,339.17h-1v-9.83h1.39l2.27,7.1v-7.1h1v9.83h-1.14l-2.51-7.95Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.46,333.69v1h-2.4v3.5H153v1h-4v-9.83h4v1h-2.95v3.35Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.16,339.17h-1v-9.83h1.39l2.27,7.1v-7.1h1v9.83h-1.14l-2.51-7.95Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,336.85c0,.88.35,1.42,1.15,1.42s1.14-.54,1.14-1.42v-7.51h1v7.45c0,1.49-.69,2.49-2.2,2.49s-2.19-1-2.19-2.49v-7.45H163Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,339.15h-1l-1.63-7.81v7.83h-1v-9.83h1.52l1.62,7.85,1.56-7.85h1.53v9.83h-1v-7.91Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.9,329.34c1.53,0,2.13.73,2.13,2.18V332c0,1-.29,1.68-1.15,1.95,1,.27,1.32,1,1.32,2.11v.82a2,2,0,0,1-2.24,2.31H174.7v-9.83Zm-.27,4.17c.87,0,1.32-.28,1.32-1.3v-.58c0-.87-.29-1.29-1.08-1.29h-1.08v3.17Zm.33,4.66c.8,0,1.16-.42,1.16-1.33V336c0-1.1-.43-1.46-1.37-1.46h-1v3.66Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.69,333.69v1h-2.4v3.5h3v1h-4v-9.83h4v1h-3v3.35Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.44,329.34c1.54,0,2.18.79,2.18,2.25v.8c0,1.08-.37,1.75-1.22,2,.9.26,1.24,1,1.24,2V338a2.51,2.51,0,0,0,.19,1.18h-1.1a2.56,2.56,0,0,1-.19-1.2v-1.54c0-1.11-.52-1.46-1.43-1.46h-.77v4.2h-1.09v-9.83Zm-.29,4.63c.87,0,1.39-.28,1.39-1.34v-.94c0-.89-.32-1.35-1.13-1.35h-1.07V334Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.78,297.19c1.55,0,2.21.91,2.21,2.4v1.18c0,1.56-.73,2.37-2.29,2.37h-1V307h-1.09v-9.82Zm-.08,5c.81,0,1.2-.38,1.2-1.32v-1.31c0-.89-.32-1.34-1.12-1.34h-1v4Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.76,299.56c0-1.5.74-2.47,2.24-2.47s2.26,1,2.26,2.47v5.08c0,1.49-.74,2.47-2.26,2.47s-2.24-1-2.24-2.47Zm1.08,5.14c0,.9.38,1.42,1.16,1.42s1.17-.52,1.17-1.42v-5.19c0-.89-.37-1.42-1.17-1.42s-1.16.53-1.16,1.42Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.55,299.55v.26h-1v-.32c0-.88-.34-1.4-1.12-1.4s-1.12.52-1.12,1.39c0,2.2,3.29,2.41,3.29,5.18,0,1.48-.71,2.45-2.21,2.45s-2.21-1-2.21-2.45v-.56h1v.61c0,.89.36,1.41,1.15,1.41s1.15-.52,1.15-1.41c0-2.19-3.29-2.4-3.29-5.16,0-1.52.71-2.46,2.18-2.46S307.55,298.06,307.55,299.55Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.93,307v-8.82h-1.81v-1h4.7v1H311V307Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.08,299.56v.89h-1v-.94c0-.89-.35-1.42-1.15-1.42s-1.15.53-1.15,1.42v5.19c0,.88.36,1.42,1.15,1.42s1.15-.54,1.15-1.42v-1.28h1v1.22c0,1.49-.71,2.47-2.22,2.47s-2.2-1-2.2-2.47v-5.08c0-1.49.7-2.47,2.2-2.47S320.08,298.07,320.08,299.56Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,299.56c0-1.5.74-2.47,2.24-2.47s2.26,1,2.26,2.47v5.08c0,1.49-.74,2.47-2.26,2.47s-2.24-1-2.24-2.47Zm1.08,5.14c0,.9.38,1.42,1.16,1.42s1.17-.52,1.17-1.42v-5.19c0-.89-.37-1.42-1.17-1.42s-1.16.53-1.16,1.42Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.83,297.19c1.53,0,2.23.93,2.23,2.44v5c0,1.5-.7,2.42-2.23,2.42h-2.3v-9.82Zm0,8.83c.78,0,1.16-.49,1.16-1.39v-5.05c0-.9-.38-1.39-1.18-1.39h-1.18V306Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.58,301.54v1h-2.4V306h2.95v1h-4.05v-9.82h4.05v1h-2.95v3.35Z",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.25,
    y: 115.13,
    width: 480.46,
    height: 29.87,
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.88,
    y: 123.67,
    width: 69.12,
    height: 21.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.68,
    y: 123.67,
    width: 69.12,
    height: 21.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.49,
    y: 123.67,
    width: 69.12,
    height: 21.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 492.29,
    y: 123.67,
    width: 69.12,
    height: 21.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.9,
    y: 415.41,
    width: 359.69,
    height: 17.72,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.9,
    y: 423.94,
    width: 359.69,
    height: 9.19,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.54,443.63s5.9,7.22,23.62,13.13H634.32s13.13-3.28,19-12.47Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.33,
    y: 430.7,
    width: 608.3,
    height: 13.8,
    rx: 1.89,
    style: {
      fill: "#969696",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356,102.33a4.59,4.59,0,1,0-4.59,4.59A4.59,4.59,0,0,0,356,102.33Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.79,187.65h0a1.31,1.31,0,0,1-1.31-1.31V148.27A1.31,1.31,0,0,1,94.79,147h0a1.32,1.32,0,0,1,1.32,1.31v38.07A1.31,1.31,0,0,1,94.79,187.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.65,
    y: 161.69,
    width: 68.2,
    height: 42.87,
    rx: 1.45,
    style: {
      fill: "#adadad"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 530.71,
    y: 165.72,
    width: 12.9,
    height: 9.48,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 487.85,
    y1: 186.58,
    x2: 495.81,
    y2: 186.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 487.85,
    y1: 169.51,
    x2: 495.81,
    y2: 169.51,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 487.85,
    y1: 197.58,
    x2: 495.81,
    y2: 197.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 500.36,
    y1: 197.58,
    x2: 508.33,
    y2: 197.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 499.61,
    y1: 186.58,
    x2: 507.57,
    y2: 186.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 511.37,
    y1: 186.58,
    x2: 519.33,
    y2: 186.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 523.12,
    y1: 186.58,
    x2: 531.09,
    y2: 186.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 534.88,
    y1: 186.58,
    x2: 542.85,
    y2: 186.58,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-29"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M420.72,351.38s-15.73-9.81-13-10.27,44.94,1.15,48.59,1.6,15.74,1.83,17.33,2.51,17.79,6.39,28.06,7.3,21,.23,22.81,1.14,8.67,8,7.07,10.49-5.93,3.2-5.93,3.2L491.89,371s-5.47-6.39-9.81-8.22-33.53-10.49-41.74-10.49S420.72,351.38,420.72,351.38Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.85,369.63S402,397.91,386.51,408.4c0,0-2.51.92,2.05.92s18.71-15.29,23.27-20.76,9.35-8.9,15.28-8.9h8.67Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.45,393.81a31.48,31.48,0,1,0,31.47,31.47A31.47,31.47,0,0,0,431.45,393.81Zm0,49.5a18,18,0,1,1,18-18A18,18,0,0,1,431.45,443.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.45,412.28a13,13,0,1,0,13,13A13,13,0,0,0,431.45,412.28Zm0,20.45a7.45,7.45,0,1,1,7.44-7.45A7.45,7.45,0,0,1,431.45,432.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.45,402.7A22.58,22.58,0,1,0,454,425.28,22.57,22.57,0,0,0,431.45,402.7Zm0,40.61a18,18,0,1,1,18-18A18,18,0,0,1,431.45,443.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "445.59 381.49 436.69 405.67 440.8 407.26 449.92 383.08 445.59 381.49",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.69,405.67s-9.35-4.11-16.88,1.59S411.37,420,411.37,420s11.86,8.66,27.37,10,31.25-.91,39-3.19a70,70,0,0,0,13.68-5.7l-19.16-21s-2.73-3.88-9.12-.23-6.62,8.44-6.62,8.44Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.92,383.08l-6.61,24.41,19.16,8.67a14,14,0,0,1,1.82-8c2.28-3.65,5.25-3.43,5.93-3s4.79,2.51,4.79,2.51l-1.82-14.37Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.78,393.81a31.48,31.48,0,1,0,31.47,31.47A31.47,31.47,0,0,0,620.78,393.81Zm0,49.5a18,18,0,1,1,18-18A18,18,0,0,1,620.78,443.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.78,412.28a13,13,0,1,0,13,13A13,13,0,0,0,620.78,412.28Zm0,20.45a7.45,7.45,0,1,1,7.44-7.45A7.45,7.45,0,0,1,620.78,432.73Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.78,402.7a22.58,22.58,0,1,0,22.58,22.58A22.58,22.58,0,0,0,620.78,402.7Zm0,40.61a18,18,0,1,1,18-18A18,18,0,0,1,620.78,443.31Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.9,396l24.83,7.64s13.37-10.1,28.64-6.55c0,0-5.45-15.55-39.83-18.28Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.45,425.28,596.05,388l4.26-2.44,21.4,37.31a2,2,0,0,1-.73,2.68l-.86.49A2,2,0,0,1,617.45,425.28Z",
    style: {
      fill: "#6e6e6e",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.9,327.89s20.07,9.58,25.55,13.68,16.65,13,18.47,15.51,7.07,10.72,5.25,13.46-3,4.33-4.11,5-6.38,1.59-8.89,4.56-23.5,36.27-23.5,36.27-7.52,12.09-8.67,12.09-14.37,4.79-31.24,4.1-37.18-5.24-40.83-5.47-7.76-2.28-9.36-3.2-6.15-3.87-12.77-10.72-10.95-9.12-10.49-17.79c0,0-52-22.81-54.52-25.32s-8.44-14.14-5.93-16.19,13-4.34,26.23-2.74,42.2,8.21,47.9,12.09a45.72,45.72,0,0,1,8.9,7.76l33.76-3.65L527.7,371s-12.09,15.73-12.09,16.87,13.46,23.73,13.46,23.73-7.07.91-12.09,1.14-9.35.91-9.35.91,44.71,2.51,51.78,2.05,11.63-8,12.77-10.95-1.83-17.33.68-26,5.71-14.37,2.29-20.3-15.29-19.16-15.29-23S569.9,327.89,569.9,327.89Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.9,327.89s-13.23,7.75-13.23,9.12,11.18,22.81,12.77,27.37-3.19,34.44-4.33,37.64-7.76,10-7.76,10l-28.28-.45-5.35,1.2-6.74-.06s-7.75-3.65-9.12-3.88-25.78-6.62-29.2-4.56-2.28,4.56-.91,5,51.55,9.58,52.69,9.58,26.23,4.1,34.9.91,17.1-15.51,18.93-19.62l1.82-4.1-7.52-6.62s.22-6.39,1.59-9.81,5.93-13.68,4.57-17.33S564,338.61,564.2,335.64,569.9,327.89,569.9,327.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.64,395.63c-2.47.69-4.94,2.62-7.13,4.86-.16.71-.3,1.23-.4,1.53-1.14,3.19-7.76,10-7.76,10l-28.28-.45-5.35,1.2-6.74-.06a48.89,48.89,0,0,0-7.6,2.48c10.91,2,20.57,3.68,21.06,3.68,1.14,0,26.23,4.1,34.9.91s17.1-15.51,18.93-19.62l1.82-4.1A22.6,22.6,0,0,0,572.64,395.63Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.5,307.81s-11.87-4.33-16.2-2.51-11.4,7.53-12.32,11.41.92,5.7,3.88,8.44,10.95,11.4,10.95,11.4l12.09-8.66,1.6-2.06s5.7-1.59,5.93-2.73a33.18,33.18,0,0,0-1.14-10.27A7.2,7.2,0,0,0,571.5,307.81Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,308.73s-2,3.87-.46,6.61,5,10.26,5.93,8-.45-9.58-2-11.63A11.27,11.27,0,0,0,571,308.73Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.41,328.7c3.4,3.51,7.4,7.85,7.4,7.85l12.09-8.66,1.6-2.06a31.52,31.52,0,0,0,4.81-1.78c-4.66-2.2-15.12-6.82-17.59-5.06S552.31,326.07,550.41,328.7Z",
    style: {
      fill: "#6e6e6e",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.7,310.55s-.22-16.19-3-16.65-7.76,1.6-7.76,1.6a13.25,13.25,0,0,1-2-10.89q.09-.36.21-.75c2.05-6.84,12.09,5.93,13,8a12.37,12.37,0,0,1,.68,5l1.37,12.78s3.88,2.28,2.06,2.51-9.13,0-7.3-1.83S553.7,310.55,553.7,310.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.86,330.07l-24.08-11c.2,2.37,1.8,3.94,4.08,6,3,2.74,10.95,11.4,10.95,11.4Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 383.16,
    y: 275.11,
    width: 75.48,
    height: 64.93,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.84,
    y: 340.05,
    width: 63.31,
    height: 1.62,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.8,412c1.93-.21,3.27-.38,3.27-.38S515.61,389,515.61,387.87,527.7,371,527.7,371l-2.05-3.65L491.89,371s19.39,22.58,25.55,29.88A127.86,127.86,0,0,1,525.8,412Z",
    style: {
      fill: "#6e6e6e",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 614.14,
    y1: 369.07,
    x2: 618.09,
    y2: 370.1,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 586.72,
    y1: 361.92,
    x2: 610.83,
    y2: 368.21,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "600.91 363.55 585.63 350.46 594.63 352.91 610.46 366.01 600.91 363.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.36,391.33c3.7.33,6.34.59,6.34.59",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.91,394s0-3.27,7.37-3.68a171.9,171.9,0,0,1,18,.78",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.44,339.86c-.91-.22-6.09-4.47-5.16-4.58,8.23-1,29.51,1.45,33.11,2,4.84.69-1.75,28.55-3.36,38.45-1.39,8.53.54,14.27.37,16a.8.8,0,0,0,.29.71l1,.88a.9.9,0,0,1,.29.56l.34,3.27a.85.85,0,0,0,.86.75,24.56,24.56,0,0,0,7.28-1.14c2.76-1.15,7.13-2.76,6-.23s-4.83,7.14-6.9,8.06-13.12,3.91-15.89,4.61c-2.07.51-7.12.51-9.52.48a.83.83,0,0,1-.75-1.19c1-2.28,3.19-7.37,3.37-10.34.23-3.92,1.16-28.57,3.23-35.71,1.81-6.23,4.33-13.68,4.94-17.13a.83.83,0,0,0-.64-1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.93,402.63l5.82,2.8a.82.82,0,0,0,.34.09c1.21,0,8.46.26,9.72.68s2.07.69.92,2.07S550.52,412,545,413.11a59.31,59.31,0,0,1-15,1.38,32.46,32.46,0,0,1-5.67-.72.84.84,0,0,1-.64-1l1.37-7.61a.85.85,0,0,1,.71-.69l13.64-1.94A.82.82,0,0,1,539.93,402.63Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.73,408.27c1-1.23.59-1.55-.5-1.93l-.94.11c-1.91,1.27-5.22,2.76-11,4.13a57.88,57.88,0,0,1-19.66,1.53.85.85,0,0,0-.92.69h0a.84.84,0,0,0,.64,1,32.46,32.46,0,0,0,5.67.72,59.31,59.31,0,0,0,15-1.38C550.52,412,555.58,409.66,556.73,408.27Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.56,325s-2.76,17.27-1.38,21.64,33.51,8.1,42.26,7.41c6.85-.54,5.8.26,12.87-.25.66-.05,1.26.29,1.13.95l-10.05,48.87a.84.84,0,0,0,.77,1,48.13,48.13,0,0,0,8-.07,24.13,24.13,0,0,0,6.57-1.91.83.83,0,0,0,.45-.52l.77-2.49a.75.75,0,0,0,0-.3l-.44-6.8a.78.78,0,0,1,.05-.34c1-2.71,11.74-39.35,12.85-43.79,1.15-4.6,2.53-8.28-.46-10.35s-41.67-9.84-41.67-9.84Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.84,336.08s14.74-5.06,23.48-7.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.75,353.24s7-.42,12.26-3.64",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.27,355.58S545,354,548.7,352.13",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "516.93 301.5 518.26 312.79 527.55 315.11 542.98 316.71 532.19 320.42 512.28 324.4 516.93 301.5",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.17,262.19s-5.06-1.15-12.89,6.21a49.42,49.42,0,0,0-14,25.1c-2.07,8.74-4.14,25.32-4.83,28.54s.23,3.68,1.84,4.6,11.51,2.77,20.26,3.23,12.89-1.16,14-2.77,0-18.64,1.38-24.17,4.14-24.63,4.14-24.63l-9-15.65Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.15,252.75l-6.9,10.13,10.58,11.28s7.37-9.44,8.52-10.13,3.68-1.84,3.68-1.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "523.64 260.92 527.84 268.89 532.35 264.03 523.64 260.92",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.94,245.85l.69,3.45s2.76,2.76,2.07,4.37-3.91,3-3.91,3-4.22,8.79-5.15,9.71-8.2-2.11-11.42-3.95-3.92-7.14-3.92-7.14l-1.61-1.15s-4.83-1.15-5.29-3.68-.69-5.3,2.07-6.91,4.83-2.53,6-2.53,17.27,2.53,17.27,2.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.64,257.82s-4.14-.24-5.07-2.77",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.83,244s-1.84,4.61-2.54,5.07-.92-3.69-5.06-2.76-3.45,5.52-2.3,6.44a9.1,9.1,0,0,0,2.76,1.38l-2.2,2.74s-1-1.13-4.47-1.36-7.6-4.14-7.83-7.13,2.53-6.68,2.53-6.68a1.93,1.93,0,0,0,1.15,2.3,7,7,0,0,0,3.68.23Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.48,244.69l33.84,1.39S543.17,236,542,232.26s-14-8-20.95-7.36-9.44,8.51-9.44,8.51Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533,245.61a91.7,91.7,0,0,0,13.58,2.08c6.91.46,11.51-1.61,11.51-3.23s-15.19,1.39-15.19,1.39Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "512.33 257.58 525.68 275.77 520.15 281.99 509.33 261.73 512.33 257.58",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.63,312.06l32.07,4.52s10.53-1.9,13.35-3.57,4.53-.71,5.11.08,1.38,6.26,1.66,7.47-2.17,2-3.15,2.32-6-1.85-6-1.85-5.5,2.43-7.54,2.12a11.76,11.76,0,0,1-4-1.53s-37.18,4.13-42.59,4.48-3.45-5.24-2.85-7.79c.91-3.88,1.6-7.3,1.6-7.3Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.75,272.37c-3.24.15-7,3.75-8.89,6.83-5.19,8.56-12.81,35.39-12.81,35.39l24.29-2.33s3.2-31.64,2.29-35C509.64,273.55,507.81,272.27,505.75,272.37Z",
    style: {
      fill: "#1D50FF",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.46,318.76a3.43,3.43,0,1,0-3.42,3.42A3.42,3.42,0,0,0,548.46,318.76Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 404.66,
    y1: 361.41,
    x2: 384.21,
    y2: 361.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 391.03,
    y1: 376.02,
    x2: 348.16,
    y2: 376.02,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 505.01,
    y1: 253.27,
    x2: 475.78,
    y2: 253.27,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 374.46,
    y1: 323.41,
    x2: 363.75,
    y2: 323.41,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-29"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 706.69,
    y1: 456.76,
    x2: 732.22,
    y2: 456.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28.61,
    y1: 456.76,
    x2: 700.56,
    y2: 456.76,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelivery);
export default __webpack_public_path__ + "static/media/delivery.1e606ad4d07758bdae706f90ef07db98.svg";
export { ForwardRef as ReactComponent };